import './Award.css'
const Award=()=>{
    const design=(
        <>
            <div className="container award-section" id='award'>
                <h2>Award & Medal</h2>
                <p>For Continually Inspires me to Do My Best and Now in <b>5th Inter-Departmental PowerPoint Presentation Competition </b>You Help 
                me Strive For Goals, I Found <b>Guidance, FriendShip, Descipline and Love,</b> Everything, In One Person. And that Person is You ! </p>
                 <br />
                 <div className="row">
                    <div className="col-md-6">
                        <h5>Student Coordinator <b>Gold Medal With Certificate</b> Power Point Presentation in Digital Marketing <b>Sliver Medal with Certificate.</b></h5>
                        <br />
                        <ul>
                            <li className='my-3 text-capitalize'>In the <b>5th Inter-Departmental Power Point Presentation</b> Competition organized by the Department of Computer Science and Engineering on Excel Your Power Point Presentation. <b>On September 26 & 27, 2019</b></li>
                            <li className='my-3 text-capitalize'>The Department of <b>Computer Science and Engineering</b> honors him for his excellent and invaluable contribution as <b>Student Coordinator</b></li>
                            <li className='my-3 text-capitalize'>Event Organizer <b> Miss Nazish Siddqui</b> & <b> Head Of Department Mr. Anand Vardhan Shukla</b> Sir Honored me with Gold Medal and Certificate</li>
                            <li className='my-3 text-capitalize'>And Principal <b>Dr. Km Moeed</b> Sir gave us his valuable time and came to our presentation and <b>we thanks all the teachers wholeheartedly.</b></li>
                        </ul>
                    </div>
                    <div className="col-md-6">
                        <div className="row">
                        <div className="col-md-6 pb-4">
                        <img src="./img/img4.jpg" className='w-100' alt="" />
                        </div>
                        <div className="col-md-6 pb-4">
                        <img src="./img/img3.jpg" className='w-100' alt="" />
                        </div>
                        </div>
                        <div className="row">
                        <div className="col-md-6 pb-4">
                        
                        <img src="./img/img2.jpg" className='w-100'  alt="" />
                        </div>
                        <div className="col-md-6 pb-4">
                        <img src="./img/img7.jpg" className='w-100 h-100' alt="" />
                        </div>
                        </div>
                    </div>
                 </div>
            </div>
        </>
    )
    return design;
}
export default Award;